import { Component, computed, inject, input } from '@angular/core';
import { dateField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { WorkGridItemObject } from '@it2go/types';
import { Router } from '@angular/router';
import { WorkServiceAnnouncementDashboardWidgetStore } from './work-service-announcement-dashboard-widget.store';
import { getServiceAnnouncementFrag } from './work-service-announcement-dashboard-widget.query';
import { ServiceAnnouncementStateEnum } from '@libs/types/src/services/enum/service-announcement.enum';
import { TableColumn } from 'packages/client/src/app/modules/shared/components/kit/table/table.types';
import { workUri } from 'packages/client/src/app/utils/router.utils';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';

@Component({
    selector: 'app-work-service-announcement-dashboard-widget',
    templateUrl: './work-service-announcement-dashboard-widget.component.html',
    providers: [WorkServiceAnnouncementDashboardWidgetStore],
    imports: [
        TableComponent,
    ],
})
export class WorkServiceAnnouncementDashboardWidgetComponent {

    protected readonly router = inject(Router);
    public readonly store = inject(WorkServiceAnnouncementDashboardWidgetStore);
    protected readonly prefix = 'serviceAnnouncement.';

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected columns = computed(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        const cols: TableColumn[] = [
            {
                name: 'type',
                dataKey: 'workData.type.name',
            },
            dateField('dateFrom'),
        ];

        if (showServiceInfo) {
            return [
                serviceField('service', 'serviceId'),
                ...cols,
            ];
        }

        return cols;
    });

    protected additionalFilters = computed<any>(() => {
        const filter = new FilterBuilder();
        filter
            .serviceIds(this.items().map(x => x.serviceId))
            .where('state', ServiceAnnouncementStateEnum.DEFAULT)
        ;

        return filter.filter()?.filter || [];
    });

    protected async detail(item: WorkGridItemObject) {
        await this.router.navigateByUrl(workUri({
                workType: WorkTypeEnum.SERVICE_ANNOUNCEMENT,
                id: item.id,
            },
            item.serviceId));
    }

    protected readonly getServiceAnnouncementFrag = getServiceAnnouncementFrag;
}
